import { render, staticRenderFns } from "./EditGroup.vue?vue&type=template&id=6c2eae19&"
import script from "./EditGroup.vue?vue&type=script&lang=ts&"
export * from "./EditGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports